export default __webpack_public_path__ + "images/TK.4a5ba17.png";